import React from 'react'
import { Link } from 'react-router-dom'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import LRTableActionsUI from '../../../widgets/layout/LRTableActionsUI'
import TransactionNavUI from './TransactionNavUI'
import './CashFlow.css'


const CashFlowUI = ({context, account, cashFlowList, onRefreshClick, onCreateClick, onUpdateClick,
   onDownloadCashFlowTemplate,  onCashFlowUploadClick
}) =>
  <div className='su_cf'>
    <LRTableActionsUI location='top'
      left={
        <span className='g_flex_left g_flex_h'>
          <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
          {
            context.permissions.includes('su_manage') &&
            <IconButtonUI icon='icon-plus' onClick={onCreateClick} />
          }
          <span className='g_m_left_100 g_large'><b>Cash Flow (Alt)</b></span>
        </span>
      }
      right={<span />}
    />

    <TransactionNavUI account={account} page='cashFlow' />

    <div style={{margin:20}}>
      <Link onClick={onDownloadCashFlowTemplate} to='#'>
        Download CashFlow Template
      </Link>

      <Link to='#' className='g_m_left_100' onClick={onCashFlowUploadClick}>
        Upload CashFlow CSV
      </Link>
    </div>

    <table><tbody>
      <tr>
        <td className='g_text_center'><span className=''><b>Month</b></span></td>
        <HeadUI val='Clime Loan' />
        <HeadUI val='Promoter' />

        <HeadUI val='Proc Fee' />
        <HeadUI val='DSRA' />
        <HeadUI val='EMI' />
        <HeadUI val='Expense' />

        <HeadUI val='Clime Rev' />
        <HeadUI val='Other Rev' />

        <HeadUI val='Balance' />
        <HeadUI val='Last Updated' />
      </tr>
      {
        cashFlowList.map((cashFlow, i) =>
          <React.Fragment key={i}>
            <tr>
              <td className='g_text_center'><b className='g_no_wrap_2'>{cashFlow.monthF}</b></td>
              <RowUI val={cashFlow.loanAmountF2} />
              <RowUI val={cashFlow.promoterFundF2} />

              <Row2UI val={cashFlow.processingFeeF2} />
              <Row2UI val={cashFlow.dsraAmountF2} />
              <Row2UI val={cashFlow.emiPaymentF2} />
              <Row2UI val={cashFlow.projectExpenseF2} />

              <RowUI val={cashFlow.climeRevenueF2} />
              <RowUI val={cashFlow.otherRevenueF2} />

              <RowUI val={cashFlow.balanceF2} />
              <RowUI val={cashFlow.lastUpdatedF1} />

              <RowRightUI cashFlow={cashFlow} onUpdateClick={onUpdateClick} />
            </tr>
            {
              cashFlow.notes &&
              <tr>
                <td className='g_info g_small' colSpan='20'>
                  {cashFlow.notes}
                </td>
              </tr>
            }
          </React.Fragment>
        )
      }
    </tbody></table>

    
  </div>

  const HeadUI = ({val}) =>
    <td className='g_text_center'><span className='g_m_left_50 g_no_wrap_2'><b>{val}</b></span></td>

  const RowUI = ({val}) =>
    <td className='g_text_right'><span className='g_no_wrap_2'>{(val && val !== '₹0') ? val : ''}</span></td>

  const Row2UI = ({val}) =>
    <td className='g_text_right'><span className='g_no_wrap_2'>{(val && val !== '₹0') ? `(${val})` : ''}</span></td>

  const RowRightUI = ({cashFlow, onUpdateClick}) =>
  <div className='g_flex_h'>
    <span className='icon icon-pencil g_link_2 g_m_left_50'
      data-year={cashFlow.year} data-month={cashFlow.month} onClick={onUpdateClick} />
  </div>

export default CashFlowUI
